import React from "react";
import "./TextR.css";

const FloatingReservationText = () => {
  return (
    <div className="textr-background">
      <div className="floating-text-container">
        <p className="floating-text">
          Reserviere jetzt deinen Platz und erlebe besondere Momente –{" "}
          <a
            href="https://www.instagram.com/moon.lounge0711/"
            target="_blank"
            rel="noopener noreferrer"
          >
            über Instagram
          </a>
          !
        </p>
      </div>
    </div>
  );
};

export default FloatingReservationText;
